/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { InputMask } from 'primereact/inputmask';
import { Col, Form, Row, Button, Card, } from 'react-bootstrap';
import { FaMagnifyingGlass, FaFileContract } from 'react-icons/fa6';
import { extract, http, layout, messages, validate } from '../../helpers';
import { auth } from '@/services/auth';

export default function ReportRescue() {
  const user = auth.store.logged.get();
  const router = useRouter();
  const [body, setBody] = useState({ plate: '', email: user?.email ?? '' });

  const onSubmit = (e) => {
    e.preventDefault();
    messages.clear();
    if (body.plate.length < 7 || !validate.plate(body.plate)) {
      layout.focus('plateRescue');
      return;
    }
    if (!validate.email(body.email)) {
      layout.focus('emailRescue');
      return;
    }
    layout.loading(true, 'Por favor, aguarde. Recuperando informações...');
    http.get(`/quick/rescue/${extract.onlyAlphaAndNumbers(body.plate).toUpperCase()}`, (result, resultError) => {
      layout.loading(false);
      if (resultError) {
        layout.focus('plateRescue');
        if (resultError.message) {
          messages.error(resultError.message, false, true);
          return;
        }
        messages.error('Ocorreu um erro ao validar sua solicitação. Por favor, tente novamente.', false, true);
        return;
      }
      router.push(`/consulta/verificacao/${result._id}`);
    }, {
      'x-email': body.email
    });
  };

  return (
    <Card className="border-0 shadow-sm rounded-4 p-4 p-md-5">
      <div className="text-center mb-4">
        <div className="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary p-3 rounded-circle mb-3">
          <FaFileContract className="fs-2" />
        </div>
        <h2 className="display-6 fw-bold text-dark mb-2">Resgate seu Laudo Veicular</h2>
        <p className="text-secondary small">Informe a placa do veículo e o e-mail cadastrado na compra para acessar imediatamente.</p>
      </div>

      <Form onSubmit={onSubmit}>
        <Row className="g-3 justify-content-center">
          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label htmlFor="plateRescue" className="fw-semibold text-secondary small mb-1">Placa do Veículo</Form.Label>
              <InputMask
                id="plateRescue"
                name="plate"
                className="form-control form-control-lg rounded-3 py-2 px-3 input-uppercase shadow-sm border-light-subtle fw-bold text-center text-sm-start"
                mask="aaa9*99"
                slotChar=""
                required
                value={body.plate}
                onChange={(e) => setBody({ ...body, plate: e.value })}
                placeholder="ABC1D23"
                autoFocus
              />
            </Form.Group>
          </Col>

          <Col xs={12} sm={8}>
            <Form.Group>
              <Form.Label htmlFor="emailRescue" className="fw-semibold text-secondary small mb-1">E-mail Cadastrado</Form.Label>
              <Form.Control
                type="email"
                id="emailRescue"
                name="email"
                placeholder="seuemail@exemplo.com.br"
                required
                className="form-control-lg rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                value={body.email}
                onChange={(e) => setBody({ ...body, email: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="text-center mt-4 pt-2">
          <Button type="submit" size="lg" className="btn-gradient-primary rounded-pill px-5 py-3 fw-bold border-0 shadow fs-5 w-100 w-md-auto">
            <FaMagnifyingGlass className="me-2" />
            Acessar Relatório
          </Button>
        </div>
      </Form>
    </Card>
  );
}
